export { default } from './BlogIndex.container'



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Blog/BlogIndex/index.js